export enum ICON_BUTTON_VARIANT {
  GHOST = 'ghost',
  SECONDARY = 'secondary',
  OUTLINE = 'outline',
  DESTRUCTIVE = 'destructive',
}
export enum ICON_BUTTON_SIZE {
  BANNER = 'banner',
  COMPACT = 'compact',
  DEFAULT = 'default',
  TOUCH = 'touch',
}
